import { Download } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { getReleasesWindowsAgentDownloadUrl } from '../../config/api'

export default function DownloadAgentButton() {
  const { t } = useTranslation()

  const handleClick = () => {
    try {
      const url = getReleasesWindowsAgentDownloadUrl()
      window.location.assign(url)
    } catch {
      // Sessão inválida: redireciona para login para recuperar o JWT.
      window.location.assign('/login')
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={t('layout.downloadAgent.buttonLabel')}
      title={t('layout.downloadAgent.tooltip')}
      className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-200 bg-white hover:bg-gray-100 transition-colors text-gray-600 hover:text-theme-primary"
    >
      <Download className="w-4 h-4" />
    </button>
  )
}
